import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {HealthCenterShort} from '../../health-center/services/http/health-center-short';
import {Utils} from '@astek/utils';
import {filter, forkJoin, map, Observable, startWith, tap} from 'rxjs';
// eslint-disable-next-line max-len
import {ApiHealthCentersShortListItemResponse} from '../../health-center/services/http/api-health-centers-short-list-item-response';
import {HealthCentreService} from '../../health-center/services/health-centre.service';
import {HealthCenterRestApiService} from '../../health-center/services/http/health-center-rest-api.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CreateOrderDialogData} from './create-order-dialog-data';
import {ApiSensorResponse} from '../services/http/api-sensor-response';
import {ApiCreateOrderRequest} from '../services/http/api-create-order-request';

@Component({
  selector: 'xp-create-order-dialog',
  templateUrl: './create-order-dialog.component.html',
  styleUrls: [
    '../../crud.common.scss',
    '../../../shared/components/dialog.common.scss',
    './create-order-dialog.component.scss',
  ],
})
export class CreateOrderDialogComponent implements OnInit {

  public isLoading: boolean = false;

  public readonly formGroup = this._formBuilder.group({
    healthCenter: new FormControl<HealthCenterShort | null>(null, [Validators.required.bind(Validators)]),
    sellingCenter: new FormControl<string>(''),
    lostDelay: new FormControl<number>(10, [Validators.required.bind(Validators), Validators.min(0).bind(Validators)]),
    stockRatioToNotify: new FormControl<number>(
      20,
      [
        Validators.required.bind(Validators),
        Validators.min(0).bind(Validators),
        Validators.max(99).bind(Validators),
      ],
    ),
  });

  public healthCenters: Array<HealthCenterShort> = [];
  public filteredHealthCenters: Array<HealthCenterShort> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: CreateOrderDialogData,
    private readonly _formBuilder: FormBuilder,
    private readonly _healthCenterService: HealthCentreService,
    private readonly _healthCenterRestApiService: HealthCenterRestApiService,
    private readonly _dialogRef: MatDialogRef<CreateOrderDialogComponent>,
  ) {
  }

  public ngOnInit(): void {
    forkJoin([
      this.initHealthCenters(),
    ]).subscribe();
  }

  public healthCenterToString(healthCenter: HealthCenterShort | null): string {
    if (Utils.isNullOrUndefined(healthCenter)) {
      return '';
    }
    return healthCenter.toString();
  }

  public onSubmit(): void {
    if (this.formGroup.invalid) {
      return;
    }
    const outputData: ApiCreateOrderRequest = {
      sensors: this._data.sensors.map((sensor: ApiSensorResponse) => sensor.id),
      healthCenter: this.formGroup.controls.healthCenter.value?.id ?? '',
      sellingCenter: this.formGroup.controls.sellingCenter.value ?? '',
      lostDelay: this.formGroup.controls.lostDelay.value ?? 0,
      stockRatioToNotify: this.formGroup.controls.stockRatioToNotify.value ?? 0,
    };
    this._dialogRef.close(outputData);
  }

  private initHealthCenters(): Observable<Array<HealthCenterShort>> {
    this.formGroup.controls['healthCenter'].valueChanges.pipe(
      startWith(''),
      filter((value: any) => typeof value === 'string'),
      map((value: string) => this._healthCenterService.filterHealthCentreList(this.healthCenters, value ?? '')),
    ).subscribe(
      (healthCenters: Array<HealthCenterShort>) => this.filteredHealthCenters = healthCenters,
    );

    return this._healthCenterRestApiService.requestHealthCenterShortListOfName().pipe(
      map((healthCenters: Array<ApiHealthCentersShortListItemResponse>) => healthCenters.map(
        (message: ApiHealthCentersShortListItemResponse) => (new HealthCenterShort()).fromMessage(message)),
      ),
      tap((response: Array<HealthCenterShort>) => {
        this.healthCenters = response;
      }),
    );
  }

}
